/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-06-07 11:26:17
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-04 11:03:55
 */
import React, { useEffect, useState } from 'react'
import {
  Form,
  Modal,
  notification,

  Tabs,
  Tree,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import styles from './versionManagement.module.css'
import { TabPane } from '../../compnents/widgets/TabBar'
import { RootDispatch } from '../../app/store'

import {
  getMenuListAsync,
  getSelectMenus,
  getSelectMenusSubmit,
  getThreeMenuListAsync,
} from './versionManagementSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { constructMenuLayers,  } from '../../models/menu'
import _ from 'lodash'

export const EditThreeMenuVersionModal = (props: {
  versionEdition?: any
  id?: number
  projectName?: string
  visible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [tabsKey, setTabsKey] = useState<any>('0')

  const [menuList, setMenus] = useState<any>([])
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([])

  const collectExpandKeys = (nodes: any): React.Key[] => {
    return nodes.map((node: any) => node.key)
  }

  const onExpand = (keys: React.Key[]) => {
    setExpandedKeys(keys)
  }

  const [selectMenuIds, setSelectMenuIds] = useState<any>([])

  const [submitMenuIds, setSubmitMenuIds] = useState<any>([])

  const onCheck = (checkedKeysValue: any, info: any) => {
    // const checkedKey = checkedKeysValue.concat(info.halfCheckedKeys) // 可以在info中获取父元素值
    const checkedKey = checkedKeysValue // 可以在info中获取父元素值
    setSelectMenuIds(checkedKeysValue)
    setSubmitMenuIds(checkedKey)
  }

  const onSelect = (selectedKeysValue: React.Key[], info: any) => {
    // const checkedKey = selectedKeysValue.concat(info.halfCheckedKeys) // 可以在info中获取父元素值
    const checkedKey = selectedKeysValue // 可以在info中获取父元素值
    setSelectMenuIds(selectedKeysValue)
    setSubmitMenuIds(checkedKey)
  }

  useEffect(() => {
    if (props?.visible) {
      if (props?.versionEdition?.toString()) {
        dispatch(getThreeMenuListAsync(props?.versionEdition))
          .then(unwrapResult)
          .then((res: any) => {
            const menus = constructMenuLayers(res)?.map((v) => {
              return {
                ...v,
                title: v?.name,
                key: v?.id,
                disabled: v?.subMenus?.length ? false:true,
                children: v?.subMenus?.map((i) => {
                  return {
                    ...i,
                    title: i?.name,
                    key: i?.id,
                    // disabled: i?.subMenus?.length ? false:true,
                    children: i?.subMenus?.map((j) => {
                      return {
                        ...j,
                        title: j?.name,
                        key: j?.id?.toString(),
                      }
                    }),
                  }
                }),
              }
            })
            setMenus(menus)
            setExpandedKeys(collectExpandKeys(menus))
          })

        dispatch(getSelectMenus(props?.id))
          .then(unwrapResult)
          .then((v: any) => {
            setSelectMenuIds(v?.sysMenuThirdIds?.split(','))
          })
      }
    }
  }, [props?.versionEdition, props?.visible])

  useEffect(() => {
    if (props?.visible) {
      setTabsKey(props?.versionEdition)
    }
  }, [props?.visible, props?.versionEdition])

  return (
    <div>
      <Modal
        className={styles.model}
        title='二三四级菜单权限编辑'
        visible={props.visible}
        okText='确认'
        cancelText='取消'
        onOk={() => {
          dispatch(
            getSelectMenusSubmit({
              id: props?.id,
              sysMenuThirdIds: submitMenuIds?.join(','),
            })
          )
            .then(unwrapResult)
            .then((v: any) => {
              notification.success({
                message: '操作成功',
              })
              form.resetFields()
              props.onOk()
              setTabsKey('')
            })
        }}
        onCancel={() => {
          form.resetFields()
          props.onCancel()
          setTabsKey('')
        }}
        width='850px'
      >
        <Tabs
          defaultActiveKey={props?.versionEdition?.toString() || '0'}
          className={styles.tabs}
          onChange={(v) => {
            setTabsKey(v)
          }}
          activeKey={props?.versionEdition?.toString() || '0'}
        >
          {props?.versionEdition == '0' ? (
            <TabPane key='0' tab='通用菜单'>
              <Tree
                checkable
                onCheck={onCheck}
                checkedKeys={selectMenuIds}
                onSelect={onSelect}
                treeData={menuList}
                expandedKeys={expandedKeys}
                onExpand={onExpand}
              />
            </TabPane>
          ) : props?.versionEdition == '1' ? (
            <TabPane key='1' tab='口腔菜单'>
              <Tree
                checkable
                onCheck={onCheck}
                checkedKeys={selectMenuIds}
                onSelect={onSelect}
                treeData={menuList}
                expandedKeys={expandedKeys}
                onExpand={onExpand}
              />
            </TabPane>
          ) : (
            ''
          )}
        </Tabs>
      </Modal>
    </div>
  )
}
